import React from "react";
import * as PropTypes from "prop-types";
import { Button } from "react-bootstrap";

const WorkAreaButtons = ({
  node,
  title,
  readOnly,
  disabled,
  isDirty,
  submit,
  reset,
  close
}) => (
  <div className="tool-window-buttons text-center">
    {readOnly ? null : (
      <Button
        disabled={disabled || !isDirty}
        onClick={() => !disabled && submit()}
        variant="secondary"
        aria-label={`Apply changes to ${title}`}
      >
        Apply
      </Button>
    )}
    {readOnly ? null : (
      <Button
        disabled={disabled}
        onClick={() => !disabled && reset(node)}
        variant="secondary"
        aria-label={`Reset ${title}`}
      >
        Reset
      </Button>
    )}
    <Button
      disabled={disabled}
      onClick={() => close(node)}
      variant="secondary"
      aria-label={`Close ${title} work area`}
    >
      Done
    </Button>
  </div>
);

WorkAreaButtons.defaultProps = {
  node: "",
  title: "",
  disabled: false,
  getData: function() {
    return {};
  },
  readOnly: false,
  isDirty: false
};

WorkAreaButtons.propTypes = {
  node: PropTypes.string.isRequired,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  getData: PropTypes.func,
  readOnly: PropTypes.bool,
  isDirty: PropTypes.bool,
  submit: PropTypes.func,
  reset: PropTypes.func,
  close: PropTypes.func
};

export default WorkAreaButtons;
